export const AppConfig = {
  // api_url: "http://localhost:5000/hairs/",

  // api_url: "http://chennai-hairs.us-east-2.elasticbeanstalk.com/hairs/",
  api_url: "https://wa.strydehr.com/hairs/",

};
